import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 md:px-6 bg-[#000000]">
      <div className="container-narrow mx-auto">
        <div className="max-w-4xl mx-auto text-left">
          <div className="space-y-8 text-gray-300">
            <p className="text-xl leading-relaxed">
              When you were younger, going to a gig felt electric. Tickets in your hand, friends by your side, a night of music ahead.
            </p>
            
            <div className="space-y-6">
              <p className="text-xl leading-relaxed">
                Now, it feels scattered. Lost emails. Forgotten dates. Group chats gone quiet when you're trying to plan. Panic at the door searching apps for tickets.
              </p>
              
              <p className="text-xl leading-relaxed">
                We've been there, too.
              </p>
            </div>
            
            <div className="space-y-6">
              <p className="text-xl leading-relaxed">
                As music lovers, we knew it didn't have to be this way. Your musical life deserved one home. So we decided to build Antix.
              </p>
              
              <p className="text-xl leading-relaxed max-w-2xl">
                Antix pulls all your event bookings straight from your inbox. Gives you one clear calendar of gigs, festivals, and nights out. Keeps your tickets ready when you are. Even helps you resell if plans change. And that's just the start.
              </p>
              
              <p className="text-xl leading-relaxed">
                Antix is how music lovers take the stress out of planning and put the joy back into live events.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;